import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { rolesApi, permissionsApi, usersApi } from './roles.api';
import type { RolesListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (filters: RolesListParams) => [...roleKeys.lists(), filters] as const,
  details: () => [...roleKeys.all, 'detail'] as const,
  detail: (id: number) => [...roleKeys.details(), id] as const,
  metrics: () => [...roleKeys.all, 'metrics'] as const
};

export const permissionKeys = {
  all: ['permissions'] as const,
  list: () => [...permissionKeys.all, 'list'] as const
};

export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (search?: string) => [...userKeys.lists(), search] as const
};

export const roleQueries = {
  list: (filters: RolesListParams = {}) =>
    queryOptions({
      queryKey: roleKeys.list(filters),
      queryFn: () => rolesApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: roleKeys.detail(id),
      queryFn: () => rolesApi.getById(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: roleKeys.metrics(),
      queryFn: () => rolesApi.getMetrics(),
      staleTime: STALE_TIME.metrics
    })
};

export const permissionQueries = {
  list: () =>
    queryOptions({
      queryKey: permissionKeys.list(),
      queryFn: () => permissionsApi.getAll()
    })
};

export const userQueries = {
  list: (search?: string) =>
    queryOptions({
      queryKey: userKeys.list(search),
      queryFn: () => usersApi.getAll(search ? { search } : undefined)
    })
};
